import { render, staticRenderFns } from "./initNode.vue?vue&type=template&id=52b5bea4&scoped=true&"
import script from "./initNode.vue?vue&type=script&lang=js&"
export * from "./initNode.vue?vue&type=script&lang=js&"
import style0 from "./initNode.vue?vue&type=style&index=0&id=52b5bea4&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52b5bea4",
  null
  
)

export default component.exports